//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
export class ClientBase {
    async transformResult(url, response, processor) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => (_headers[k] = v));
        }
        if (status >= 200 && status < 300) {
            const _responseText = await response.text();
            let result200 = null;
            result200 = _responseText === "" ? null : JSON.parse(_responseText);
            return result200;
        }
        else if (status === 404) {
            const _responseText_1 = await response.text();
            return this.throwException("Resource not found.", status, _responseText_1, _headers);
        }
        else {
            const _responseText_2 = await response.text();
            let result_1 = null;
            if (_responseText_2) {
                try {
                    result_1 = JSON.parse(_responseText_2);
                    if (result_1?.ModelState) {
                        for (const error in result_1.ModelState) {
                            if (typeof result_1.ModelState[error] !== "undefined") {
                                result_1.message = result_1.ModelState[error];
                            }
                        }
                    }
                }
                catch (e) { }
            }
            return this.throwException(result_1
                ? result_1.message || result_1.Message
                : `An unexpected server error occurred when accessing ${url} : ${_responseText_2}`, status, _responseText_2, _headers);
        }
    }
    throwException(message, status, response, headers, result) {
        if (result !== null && result !== undefined)
            throw result;
        else
            throw new SwaggerException(message, status, response, headers, null);
    }
}
export class Client extends ClientBase {
    http;
    baseUrl;
    jsonParseReviver = undefined;
    constructor(baseUrl, http) {
        super();
        this.http = http ? http : window;
        this.baseUrl = baseUrl ?? "";
    }
    /**
     * Get catalog by id asynchronously.
     * @param id (optional) Gets or sets the id.
     * @return OK
     */
    catalog(id) {
        let url_ = this.baseUrl + "/api/v1/Catalog?";
        if (id === null)
            throw new Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "Id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCatalog(_response);
        });
    }
    processCatalog(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CatalogResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get catalog owner asynchronously.
     * @param catalogId The catalog id.
     * @return OK
     */
    owner(catalogId) {
        let url_ = this.baseUrl + "/api/v1/Catalog/{catalogId}/owner";
        if (catalogId === undefined || catalogId === null)
            throw new Error("The parameter 'catalogId' must be defined.");
        url_ = url_.replace("{catalogId}", encodeURIComponent("" + catalogId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processOwner(_response);
        });
    }
    processOwner(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OwnerResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get a list of collections by collection ids asynchronously.
     * @param catalogId (optional) Gets or sets the catalog id.
     * @param page (optional) The page number.
     * @param pageSize (optional) The page size.
     * @return OK
     */
    collections(catalogId, page, pageSize) {
        let url_ = this.baseUrl + "/api/v1/Collections?";
        if (catalogId === null)
            throw new Error("The parameter 'catalogId' cannot be null.");
        else if (catalogId !== undefined)
            url_ += "CatalogId=" + encodeURIComponent("" + catalogId) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCollections(_response);
        });
    }
    processCollections(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CollectionsPagedResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get collection by id asynchronously.
     * @param collectionId The collection id to lookup by.
     * @return OK
     */
    collections2(collectionId) {
        let url_ = this.baseUrl + "/api/v1/Collections/{collectionId}";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCollections2(_response);
        });
    }
    processCollections2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CollectionResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get collection owner asynchronously.
     * @param collectionId The collection id.
     * @return OK
     */
    owner2(collectionId) {
        let url_ = this.baseUrl + "/api/v1/Collections/{collectionId}/owner";
        if (collectionId === undefined || collectionId === null)
            throw new Error("The parameter 'collectionId' must be defined.");
        url_ = url_.replace("{collectionId}", encodeURIComponent("" + collectionId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processOwner2(_response);
        });
    }
    processOwner2(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OwnerResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets oldest collection from project.
     * @param projectId (optional) The project id.
     * @return OK
     */
    oldest(projectId) {
        let url_ = this.baseUrl + "/api/v1/Collections/oldest?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processOldest(_response);
        });
    }
    processOldest(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CollectionResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get by collection id asynchronously.
     * @param collectionId (optional) The collection id.
     * @param isInCatalog (optional) Is this request in the catalog view
     * @param videoStatusType (optional) Gets or sets the video status type.
     * @param page (optional) The page number.
     * @param pageSize (optional) The page size.
     * @return OK
     */
    collectionVideos(collectionId, isInCatalog, videoStatusType, page, pageSize) {
        let url_ = this.baseUrl + "/api/v1/CollectionVideos?";
        if (collectionId === null)
            throw new Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "CollectionId=" + encodeURIComponent("" + collectionId) + "&";
        if (isInCatalog === null)
            throw new Error("The parameter 'isInCatalog' cannot be null.");
        else if (isInCatalog !== undefined)
            url_ += "IsInCatalog=" + encodeURIComponent("" + isInCatalog) + "&";
        if (videoStatusType === null)
            throw new Error("The parameter 'videoStatusType' cannot be null.");
        else if (videoStatusType !== undefined)
            url_ += "VideoStatusType=" + encodeURIComponent("" + videoStatusType) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processCollectionVideos(_response);
        });
    }
    processCollectionVideos(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CollectionVideosPagedResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get by search term and project id asynchronously.
     * @param projectId (optional) The project id.
     * @param searchTerm (optional) Gets or sets the video status type.
     * @param page (optional) The page number.
     * @param pageSize (optional) The page size.
     * @return OK
     */
    bySearch(projectId, searchTerm, page, pageSize) {
        let url_ = this.baseUrl + "/api/v1/CollectionVideos/BySearch?";
        if (projectId === null)
            throw new Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "ProjectId=" + encodeURIComponent("" + projectId) + "&";
        if (searchTerm === null)
            throw new Error("The parameter 'searchTerm' cannot be null.");
        else if (searchTerm !== undefined)
            url_ += "SearchTerm=" + encodeURIComponent("" + searchTerm) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "Page=" + encodeURIComponent("" + page) + "&";
        if (pageSize === null)
            throw new Error("The parameter 'pageSize' cannot be null.");
        else if (pageSize !== undefined)
            url_ += "PageSize=" + encodeURIComponent("" + pageSize) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processBySearch(_response);
        });
    }
    processBySearch(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CatalogSearchPagedResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get by collection id asynchronously.
     * @param collectionId (optional) The collection id.
     * @return OK
     * @deprecated
     */
    nextEvents(collectionId) {
        let url_ = this.baseUrl + "/api/v1/CollectionVideos/NextEvents?";
        if (collectionId === null)
            throw new Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "CollectionId=" + encodeURIComponent("" + collectionId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processNextEvents(_response);
        });
    }
    processNextEvents(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CollectionVideosResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get single video asynchronously.
     * @param collectionId (optional) Gets or sets the collection id.
     * @param broadcastId (optional) Gets or sets the broadcast id.
     * @return OK
     */
    byBroadcast(collectionId, broadcastId) {
        let url_ = this.baseUrl + "/api/v1/CollectionVideos/ByBroadcast?";
        if (collectionId === null)
            throw new Error("The parameter 'collectionId' cannot be null.");
        else if (collectionId !== undefined)
            url_ += "CollectionId=" + encodeURIComponent("" + collectionId) + "&";
        if (broadcastId === null)
            throw new Error("The parameter 'broadcastId' cannot be null.");
        else if (broadcastId !== undefined)
            url_ += "BroadcastId=" + encodeURIComponent("" + broadcastId) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processByBroadcast(_response);
        });
    }
    processByBroadcast(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = CollectionVideoResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 204) {
            return response.text().then((_responseText) => {
                return throwException("No Content", status, _responseText, _headers);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Validate password.
     * @param body (optional) The request.
     * @return OK
     */
    validate(body) {
        let url_ = this.baseUrl + "/api/v1/Password/validate";
        url_ = url_.replace(/[?&]$/, "");
        const content_ = JSON.stringify(body);
        let options_ = {
            body: content_,
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processValidate(_response);
        });
    }
    processValidate(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = PasswordValidationResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get meta data by product id asynchronously.
     * @param productIds Gets or sets the product ids.
     * @return OK
     */
    meta(productIds) {
        let url_ = this.baseUrl + "/api/v1/Product/meta?";
        if (productIds === undefined || productIds === null)
            throw new Error("The parameter 'productIds' must be defined and cannot be null.");
        else
            productIds && productIds.forEach(item => { url_ += "ProductIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processMeta(_response);
        });
    }
    processMeta(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = ProductMetaDataDetailsResponseMetaDataResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Gets the ID by custom slug.
     * @param slug The slug to lookup.
     * @return OK
     */
    lookup(slug) {
        let url_ = this.baseUrl + "/api/v1/Slug/Lookup?";
        if (slug === undefined || slug === null)
            throw new Error("The parameter 'slug' must be defined and cannot be null.");
        else
            url_ += "slug=" + encodeURIComponent("" + slug) + "&";
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processLookup(_response);
        });
    }
    processLookup(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = SlugLookupResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status === 404) {
            return response.text().then((_responseText) => {
                let result404 = null;
                let resultData404 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result404 = ProblemDetails.fromJS(resultData404);
                return throwException("Not Found", status, _responseText, _headers, result404);
            });
        }
        else if (status === 400) {
            return response.text().then((_responseText) => {
                let result400 = null;
                let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result400 = ProblemDetails.fromJS(resultData400);
                return throwException("Bad Request", status, _responseText, _headers, result400);
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get the videos asynchronously.
     * @param broadcastId The broadcast id.
     * @return OK
     */
    videos(broadcastId) {
        let url_ = this.baseUrl + "/api/v1/Videos/{broadcastId}";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processVideos(_response);
        });
    }
    processVideos(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = BroadcastResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
    /**
     * Get broadcast owner asynchronously.
     * @param broadcastId The broadcast id.
     * @return OK
     */
    owner3(broadcastId) {
        let url_ = this.baseUrl + "/api/v1/Videos/{broadcastId}/owner";
        if (broadcastId === undefined || broadcastId === null)
            throw new Error("The parameter 'broadcastId' must be defined.");
        url_ = url_.replace("{broadcastId}", encodeURIComponent("" + broadcastId));
        url_ = url_.replace(/[?&]$/, "");
        let options_ = {
            method: "GET",
            headers: {
                "Accept": "text/plain"
            }
        };
        return this.http.fetch(url_, options_).then((_response) => {
            return this.processOwner3(_response);
        });
    }
    processOwner3(response) {
        const status = response.status;
        let _headers = {};
        if (response.headers && response.headers.forEach) {
            response.headers.forEach((v, k) => _headers[k] = v);
        }
        ;
        if (status === 200) {
            return response.text().then((_responseText) => {
                let result200 = null;
                let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result200 = OwnerResponse.fromJS(resultData200);
                return result200;
            });
        }
        else if (status !== 200 && status !== 204) {
            return response.text().then((_responseText) => {
                return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            });
        }
        return Promise.resolve(null);
    }
}
/** The broadcast details response. */
export class BroadcastDetailsResponse {
    /** Gets or sets the id. */
    id;
    /** Gets or sets the title. */
    title;
    /** Gets or sets the description. */
    description;
    /** Gets or sets the created by. */
    createdBy;
    /** Gets or sets the starts at. */
    startsAt;
    /** Gets or sets the active at. */
    activeAt;
    /** Gets or sets the ended at. */
    endedAt;
    /** Gets or sets the created at. */
    createdAt;
    /** Gets or sets the project id. */
    projectId;
    /** Gets or sets the input id. */
    inputId;
    /** Gets or sets the video id. */
    videoId;
    /** Gets or sets a value indicating whether protected. */
    isProtected;
    /** Gets or sets the input effective deletion date. */
    inputEffectiveDeletionDate;
    broadcastType;
    broadcastStatus;
    /** Gets or sets  a value indicating whether to enable donations. */
    enableDonations;
    /** Gets or sets  a value indicating whether to enable recording. */
    enableRecording;
    /** Gets or sets  a value indicating whether to enable switcher player. */
    enableSwitcherPlayer;
    /** Gets or sets  a value indicating whether to enable live shopping. */
    enableLiveShopping;
    /** Gets or sets the thumbnail asset id. */
    thumbnailAssetId;
    /** Gets or sets the duration. */
    duration;
    /** Gets or sets a value indicating whether show in catalog. */
    showInCatalog;
    /** Toggles if the countdown is shown over the thumbnail is the video is premiering. */
    showPremiereCountdown;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.createdBy = _data["createdBy"];
            this.startsAt = _data["startsAt"] ? new Date(_data["startsAt"].toString()) : undefined;
            this.activeAt = _data["activeAt"] ? new Date(_data["activeAt"].toString()) : undefined;
            this.endedAt = _data["endedAt"] ? new Date(_data["endedAt"].toString()) : undefined;
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.projectId = _data["projectId"];
            this.inputId = _data["inputId"];
            this.videoId = _data["videoId"];
            this.isProtected = _data["isProtected"];
            this.inputEffectiveDeletionDate = _data["inputEffectiveDeletionDate"] ? new Date(_data["inputEffectiveDeletionDate"].toString()) : undefined;
            this.broadcastType = _data["broadcastType"];
            this.broadcastStatus = _data["broadcastStatus"];
            this.enableDonations = _data["enableDonations"];
            this.enableRecording = _data["enableRecording"];
            this.enableSwitcherPlayer = _data["enableSwitcherPlayer"];
            this.enableLiveShopping = _data["enableLiveShopping"];
            this.thumbnailAssetId = _data["thumbnailAssetId"];
            this.duration = _data["duration"];
            this.showInCatalog = _data["showInCatalog"];
            this.showPremiereCountdown = _data["showPremiereCountdown"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BroadcastDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["createdBy"] = this.createdBy;
        data["startsAt"] = this.startsAt ? this.startsAt.toISOString() : undefined;
        data["activeAt"] = this.activeAt ? this.activeAt.toISOString() : undefined;
        data["endedAt"] = this.endedAt ? this.endedAt.toISOString() : undefined;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["projectId"] = this.projectId;
        data["inputId"] = this.inputId;
        data["videoId"] = this.videoId;
        data["isProtected"] = this.isProtected;
        data["inputEffectiveDeletionDate"] = this.inputEffectiveDeletionDate ? this.inputEffectiveDeletionDate.toISOString() : undefined;
        data["broadcastType"] = this.broadcastType;
        data["broadcastStatus"] = this.broadcastStatus;
        data["enableDonations"] = this.enableDonations;
        data["enableRecording"] = this.enableRecording;
        data["enableSwitcherPlayer"] = this.enableSwitcherPlayer;
        data["enableLiveShopping"] = this.enableLiveShopping;
        data["thumbnailAssetId"] = this.thumbnailAssetId;
        data["duration"] = this.duration;
        data["showInCatalog"] = this.showInCatalog;
        data["showPremiereCountdown"] = this.showPremiereCountdown;
        return data;
    }
}
/** The broadcast response. */
export class BroadcastResponse {
    details;
    thumbnail;
    /** Gets or sets the videos. */
    videos;
    /** Gets or sets the web links. */
    webLinks;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? BroadcastDetailsResponse.fromJS(_data["details"]) : undefined;
            this.thumbnail = _data["thumbnail"] ? ThumbnailResponse.fromJS(_data["thumbnail"]) : undefined;
            if (Array.isArray(_data["videos"])) {
                this.videos = [];
                for (let item of _data["videos"])
                    this.videos.push(VideoResponse.fromJS(item));
            }
            if (Array.isArray(_data["webLinks"])) {
                this.webLinks = [];
                for (let item of _data["webLinks"])
                    this.webLinks.push(WebLinkResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new BroadcastResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : undefined;
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        if (Array.isArray(this.webLinks)) {
            data["webLinks"] = [];
            for (let item of this.webLinks)
                data["webLinks"].push(item.toJSON());
        }
        return data;
    }
}
/** The catalog response details. */
export class CatalogDetailsResponse {
    /** Gets or sets the catalog id. */
    id;
    /** Gets or sets the title. */
    title;
    /** Gets or sets the description. */
    description;
    /** Gets or sets the catalog's thumbnail asset id. */
    thumbnailAssetId;
    /** Gets or sets the project id. */
    projectId;
    /** Gets or sets the featured broadcast id. */
    featuredBroadcastId;
    /** Gets or sets a value indicating whether to enable featured broadcast. */
    enableFeaturedBroadcast;
    /** Gets or sets the created at. */
    createdAt;
    /** Gets or sets the updated at. */
    updatedAt;
    /** Gets or Sets the Button, Backgrounds, and Links color. If set, this will override the initial color setting. */
    buttonBackgroundsLinksColor;
    /** Gets or Sets the Button Text color. If set, this will override the initial color setting. */
    buttonTextColor;
    /** Gets or Sets the player controls color. If set, this will override the initial color setting. */
    playerControlsColor;
    defaultInteractiveTab;
    embeddedDisplay;
    /** Gets or sets showing titles in embedded display. */
    showTitles;
    /** Gets or Sets the embed background color. If set, this will override the initial color setting. */
    embedBackgroundColor;
    /** Gets or Sets the embed text color. If set, this will override the initial color setting. */
    embedTextColor;
    /** Gets or Sets the interactive panel background color. If set, this will override the initial color setting. */
    interactivePanelBackgroundColor;
    /** Gets or Sets the interactive panel text color. If set, this will override the initial color setting. */
    interactivePanelTextColor;
    /** Gets or Sets whether or not max embed width is enabled. If true, the MaxEmbedWidth may be customized by user. */
    enableMaxEmbedWidth;
    /** Gets or Sets the maximum embed width (only settable when EnableMaxEmbedWidth = true). */
    maxEmbedWidth;
    /** Gets or sets a value indicating whether to enable horizontal padding. */
    enableHorizontalPadding;
    /** Gets or Sets the upcoming background color. If set, this will override the initial color setting. */
    upcomingBackgroundColor;
    /** Gets or Sets the upcoming overlay text color. If set, this will override the initial color setting. */
    upcomingTextColor;
    /** Gets or sets whether the catalog has email gating enabled. */
    isEmailGatingEnabled;
    /** Gets or sets whether the catalog has password gating enabled. */
    isPasswordGatingEnabled;
    /** Gets or sets a value indicating whether search is enabled for the catalog. */
    isSearchEnabled;
    /** Gets or sets the Google Font Family for the catalog. */
    googleFontFamily;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.title = _data["title"];
            this.description = _data["description"];
            this.thumbnailAssetId = _data["thumbnailAssetId"];
            this.projectId = _data["projectId"];
            this.featuredBroadcastId = _data["featuredBroadcastId"];
            this.enableFeaturedBroadcast = _data["enableFeaturedBroadcast"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : undefined;
            this.buttonBackgroundsLinksColor = _data["buttonBackgroundsLinksColor"];
            this.buttonTextColor = _data["buttonTextColor"];
            this.playerControlsColor = _data["playerControlsColor"];
            this.defaultInteractiveTab = _data["defaultInteractiveTab"];
            this.embeddedDisplay = _data["embeddedDisplay"];
            this.showTitles = _data["showTitles"];
            this.embedBackgroundColor = _data["embedBackgroundColor"];
            this.embedTextColor = _data["embedTextColor"];
            this.interactivePanelBackgroundColor = _data["interactivePanelBackgroundColor"];
            this.interactivePanelTextColor = _data["interactivePanelTextColor"];
            this.enableMaxEmbedWidth = _data["enableMaxEmbedWidth"];
            this.maxEmbedWidth = _data["maxEmbedWidth"];
            this.enableHorizontalPadding = _data["enableHorizontalPadding"];
            this.upcomingBackgroundColor = _data["upcomingBackgroundColor"];
            this.upcomingTextColor = _data["upcomingTextColor"];
            this.isEmailGatingEnabled = _data["isEmailGatingEnabled"];
            this.isPasswordGatingEnabled = _data["isPasswordGatingEnabled"];
            this.isSearchEnabled = _data["isSearchEnabled"];
            this.googleFontFamily = _data["googleFontFamily"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["title"] = this.title;
        data["description"] = this.description;
        data["thumbnailAssetId"] = this.thumbnailAssetId;
        data["projectId"] = this.projectId;
        data["featuredBroadcastId"] = this.featuredBroadcastId;
        data["enableFeaturedBroadcast"] = this.enableFeaturedBroadcast;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : undefined;
        data["buttonBackgroundsLinksColor"] = this.buttonBackgroundsLinksColor;
        data["buttonTextColor"] = this.buttonTextColor;
        data["playerControlsColor"] = this.playerControlsColor;
        data["defaultInteractiveTab"] = this.defaultInteractiveTab;
        data["embeddedDisplay"] = this.embeddedDisplay;
        data["showTitles"] = this.showTitles;
        data["embedBackgroundColor"] = this.embedBackgroundColor;
        data["embedTextColor"] = this.embedTextColor;
        data["interactivePanelBackgroundColor"] = this.interactivePanelBackgroundColor;
        data["interactivePanelTextColor"] = this.interactivePanelTextColor;
        data["enableMaxEmbedWidth"] = this.enableMaxEmbedWidth;
        data["maxEmbedWidth"] = this.maxEmbedWidth;
        data["enableHorizontalPadding"] = this.enableHorizontalPadding;
        data["upcomingBackgroundColor"] = this.upcomingBackgroundColor;
        data["upcomingTextColor"] = this.upcomingTextColor;
        data["isEmailGatingEnabled"] = this.isEmailGatingEnabled;
        data["isPasswordGatingEnabled"] = this.isPasswordGatingEnabled;
        data["isSearchEnabled"] = this.isSearchEnabled;
        data["googleFontFamily"] = this.googleFontFamily;
        return data;
    }
}
/** The catalog response. */
export class CatalogResponse {
    /** Gets or sets  a value indicating whether to creator is valid. */
    creatorIsValid;
    details;
    featuredTrailer;
    /** Gets or sets the entitlements. */
    entitlements;
    /** Gets a value indicating whether gated. */
    isGated;
    /** Gets a value indicating whether entitled. */
    isEntitled;
    thumbnail;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.creatorIsValid = _data["creatorIsValid"];
            this.details = _data["details"] ? CatalogDetailsResponse.fromJS(_data["details"]) : undefined;
            this.featuredTrailer = _data["featuredTrailer"] ? BroadcastResponse.fromJS(_data["featuredTrailer"]) : undefined;
            if (Array.isArray(_data["entitlements"])) {
                this.entitlements = [];
                for (let item of _data["entitlements"])
                    this.entitlements.push(EntitlementResponse.fromJS(item));
            }
            this.isGated = _data["isGated"];
            this.isEntitled = _data["isEntitled"];
            this.thumbnail = _data["thumbnail"] ? ThumbnailResponse.fromJS(_data["thumbnail"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["creatorIsValid"] = this.creatorIsValid;
        data["details"] = this.details ? this.details.toJSON() : undefined;
        data["featuredTrailer"] = this.featuredTrailer ? this.featuredTrailer.toJSON() : undefined;
        if (Array.isArray(this.entitlements)) {
            data["entitlements"] = [];
            for (let item of this.entitlements)
                data["entitlements"].push(item.toJSON());
        }
        data["isGated"] = this.isGated;
        data["isEntitled"] = this.isEntitled;
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : undefined;
        return data;
    }
}
/** Response for a paginated collection video search result. */
export class CatalogSearchPagedResponse {
    /** Gets or sets the search term used in the query. */
    searchTerm;
    /** Gets or sets the project id associated with the search. */
    projectId;
    /** Gets or sets the collection video search response containing the results. */
    videos;
    /** Gets or sets the total pages. */
    totalPages;
    /** Gets or sets the total records. */
    totalRecords;
    /** Gets or sets the page. */
    page;
    /** Gets or sets the page size. */
    pageSize;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.searchTerm = _data["searchTerm"];
            this.projectId = _data["projectId"];
            if (Array.isArray(_data["videos"])) {
                this.videos = [];
                for (let item of _data["videos"])
                    this.videos.push(CollectionVideoSearchResponse.fromJS(item));
            }
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CatalogSearchPagedResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["searchTerm"] = this.searchTerm;
        data["projectId"] = this.projectId;
        if (Array.isArray(this.videos)) {
            data["videos"] = [];
            for (let item of this.videos)
                data["videos"].push(item.toJSON());
        }
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}
/** The collection details response. */
export class CollectionDetailsResponse {
    /** Gets or sets the id. */
    id;
    /** Gets or Sets the project id. */
    projectId;
    /** Gets or Sets the player name. */
    name;
    /** Gets or Sets the player description. */
    description;
    /** Gets or Sets the player thumbnail asset id. */
    thumbnailAssetId;
    /** Gets or Sets the primary color. */
    primaryColor;
    /** Gets or Sets the secondary color. */
    secondaryColor;
    /** Gets or Sets the donate button text. */
    donateButtonText;
    /** Gets or Sets the donate button color. If set, this will override the primary color */
    donateButtonColor;
    /** Gets or Sets the donate button text color. If set, this will override the primary text color */
    donateButtonTextColor;
    /** Gets or Sets the donate popup headline text. */
    donatePopupHeadlineText;
    /** Gets or Sets the player controls color. If set, this will override the primary color */
    playerControlsColor;
    /** Gets or Sets the logo background color. If set, this will override the secondary color */
    logoBackgroundColor;
    /** Gets or Sets a value indicating whether to enable branding on the video player.  Default: false */
    enableBranding;
    /** Gets or Sets a value indicating whether enable playlist on switcher player. */
    enablePlaylist;
    idleState;
    /** Gets or Sets the idle image asset id. Used with VideoPlayerIdleState.Image */
    idleImageAssetId;
    /** Gets or Sets a value indicating whether enable countdown. Used with VideoPlayerIdleState.NextEvent */
    enableCountdown;
    /** Gets or Sets the idle broadcast id. Used with VideoPlayerIdleState.SelectVideo */
    idleBroadcastId;
    /** Gets or Sets whether the player should auto open in interactive mode on play. */
    autoOpenInteractiveMode;
    defaultInteractiveTab;
    aspectRatio;
    /** Gets or Sets the rank. */
    ordinalRank_Rank;
    /** Gets or Sets the ordinal. */
    ordinalRank_Ordinal;
    /** Gets or sets showing in catalog. */
    showInCatalog;
    embeddedDisplay;
    /** Gets or sets showing titles in embedded display. */
    showTitles;
    /** Gets or Sets the embed background color. If set, this will override the initial color setting. */
    embedBackgroundColor;
    /** Gets or Sets the embed text color. If set, this will override the initial color setting. */
    embedTextColor;
    /** Gets or Sets the interactive panel background color. If set, this will override the initial color setting. */
    interactivePanelBackgroundColor;
    /** Gets or Sets the interactive panel text color. If set, this will override the initial color setting. */
    interactivePanelTextColor;
    /** Gets or Sets whether or not max embed width is enabled. If true, the MaxEmbedWidth may be customized by user. */
    enableMaxEmbedWidth;
    /** Gets or Sets the maximum embed width (only settable when EnableMaxEmbedWidth = true). */
    maxEmbedWidth;
    /** Gets or sets a value indicating whether to enable horizontal padding. */
    enableHorizontalPadding;
    /** Gets or Sets the upcoming overlay text color. If set, this will override the initial color setting. */
    upcomingTextColor;
    /** Gets or sets a value indicating whether library player. */
    isLibraryPlayer;
    /** Gets or sets a value indicating whether livestream player. */
    isLivestreamPlayer;
    /** Gets or sets whether the collection has email gating enabled. */
    isEmailGatingEnabled;
    /** Gets or sets whether the collection has password gating enabled. */
    isPasswordGatingEnabled;
    defaultCollectionTab;
    /** Gets or sets the Google Font Family for the collection. */
    googleFontFamily;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.thumbnailAssetId = _data["thumbnailAssetId"];
            this.primaryColor = _data["primaryColor"];
            this.secondaryColor = _data["secondaryColor"];
            this.donateButtonText = _data["donateButtonText"];
            this.donateButtonColor = _data["donateButtonColor"];
            this.donateButtonTextColor = _data["donateButtonTextColor"];
            this.donatePopupHeadlineText = _data["donatePopupHeadlineText"];
            this.playerControlsColor = _data["playerControlsColor"];
            this.logoBackgroundColor = _data["logoBackgroundColor"];
            this.enableBranding = _data["enableBranding"];
            this.enablePlaylist = _data["enablePlaylist"];
            this.idleState = _data["idleState"];
            this.idleImageAssetId = _data["idleImageAssetId"];
            this.enableCountdown = _data["enableCountdown"];
            this.idleBroadcastId = _data["idleBroadcastId"];
            this.autoOpenInteractiveMode = _data["autoOpenInteractiveMode"];
            this.defaultInteractiveTab = _data["defaultInteractiveTab"];
            this.aspectRatio = _data["aspectRatio"];
            this.ordinalRank_Rank = _data["ordinalRank_Rank"];
            this.ordinalRank_Ordinal = _data["ordinalRank_Ordinal"];
            this.showInCatalog = _data["showInCatalog"];
            this.embeddedDisplay = _data["embeddedDisplay"];
            this.showTitles = _data["showTitles"];
            this.embedBackgroundColor = _data["embedBackgroundColor"];
            this.embedTextColor = _data["embedTextColor"];
            this.interactivePanelBackgroundColor = _data["interactivePanelBackgroundColor"];
            this.interactivePanelTextColor = _data["interactivePanelTextColor"];
            this.enableMaxEmbedWidth = _data["enableMaxEmbedWidth"];
            this.maxEmbedWidth = _data["maxEmbedWidth"];
            this.enableHorizontalPadding = _data["enableHorizontalPadding"];
            this.upcomingTextColor = _data["upcomingTextColor"];
            this.isLibraryPlayer = _data["isLibraryPlayer"];
            this.isLivestreamPlayer = _data["isLivestreamPlayer"];
            this.isEmailGatingEnabled = _data["isEmailGatingEnabled"];
            this.isPasswordGatingEnabled = _data["isPasswordGatingEnabled"];
            this.defaultCollectionTab = _data["defaultCollectionTab"];
            this.googleFontFamily = _data["googleFontFamily"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["description"] = this.description;
        data["thumbnailAssetId"] = this.thumbnailAssetId;
        data["primaryColor"] = this.primaryColor;
        data["secondaryColor"] = this.secondaryColor;
        data["donateButtonText"] = this.donateButtonText;
        data["donateButtonColor"] = this.donateButtonColor;
        data["donateButtonTextColor"] = this.donateButtonTextColor;
        data["donatePopupHeadlineText"] = this.donatePopupHeadlineText;
        data["playerControlsColor"] = this.playerControlsColor;
        data["logoBackgroundColor"] = this.logoBackgroundColor;
        data["enableBranding"] = this.enableBranding;
        data["enablePlaylist"] = this.enablePlaylist;
        data["idleState"] = this.idleState;
        data["idleImageAssetId"] = this.idleImageAssetId;
        data["enableCountdown"] = this.enableCountdown;
        data["idleBroadcastId"] = this.idleBroadcastId;
        data["autoOpenInteractiveMode"] = this.autoOpenInteractiveMode;
        data["defaultInteractiveTab"] = this.defaultInteractiveTab;
        data["aspectRatio"] = this.aspectRatio;
        data["ordinalRank_Rank"] = this.ordinalRank_Rank;
        data["ordinalRank_Ordinal"] = this.ordinalRank_Ordinal;
        data["showInCatalog"] = this.showInCatalog;
        data["embeddedDisplay"] = this.embeddedDisplay;
        data["showTitles"] = this.showTitles;
        data["embedBackgroundColor"] = this.embedBackgroundColor;
        data["embedTextColor"] = this.embedTextColor;
        data["interactivePanelBackgroundColor"] = this.interactivePanelBackgroundColor;
        data["interactivePanelTextColor"] = this.interactivePanelTextColor;
        data["enableMaxEmbedWidth"] = this.enableMaxEmbedWidth;
        data["maxEmbedWidth"] = this.maxEmbedWidth;
        data["enableHorizontalPadding"] = this.enableHorizontalPadding;
        data["upcomingTextColor"] = this.upcomingTextColor;
        data["isLibraryPlayer"] = this.isLibraryPlayer;
        data["isLivestreamPlayer"] = this.isLivestreamPlayer;
        data["isEmailGatingEnabled"] = this.isEmailGatingEnabled;
        data["isPasswordGatingEnabled"] = this.isPasswordGatingEnabled;
        data["defaultCollectionTab"] = this.defaultCollectionTab;
        data["googleFontFamily"] = this.googleFontFamily;
        return data;
    }
}
/** The collection response. */
export class CollectionResponse {
    /** Gets or sets a value indicating whether the creator has valid access. */
    creatorIsValid;
    details;
    featuredTrailer;
    /** Gets a value indicating whether gated. */
    isGated;
    /** Gets a value indicating whether entitled. */
    isEntitled;
    /** Gets or sets the entitlements. */
    entitlements;
    /** Gets or sets the web links. */
    webLinks;
    thumbnail;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.creatorIsValid = _data["creatorIsValid"];
            this.details = _data["details"] ? CollectionDetailsResponse.fromJS(_data["details"]) : undefined;
            this.featuredTrailer = _data["featuredTrailer"] ? BroadcastResponse.fromJS(_data["featuredTrailer"]) : undefined;
            this.isGated = _data["isGated"];
            this.isEntitled = _data["isEntitled"];
            if (Array.isArray(_data["entitlements"])) {
                this.entitlements = [];
                for (let item of _data["entitlements"])
                    this.entitlements.push(EntitlementResponse.fromJS(item));
            }
            if (Array.isArray(_data["webLinks"])) {
                this.webLinks = [];
                for (let item of _data["webLinks"])
                    this.webLinks.push(WebLinkResponse.fromJS(item));
            }
            this.thumbnail = _data["thumbnail"] ? ThumbnailResponse.fromJS(_data["thumbnail"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["creatorIsValid"] = this.creatorIsValid;
        data["details"] = this.details ? this.details.toJSON() : undefined;
        data["featuredTrailer"] = this.featuredTrailer ? this.featuredTrailer.toJSON() : undefined;
        data["isGated"] = this.isGated;
        data["isEntitled"] = this.isEntitled;
        if (Array.isArray(this.entitlements)) {
            data["entitlements"] = [];
            for (let item of this.entitlements)
                data["entitlements"].push(item.toJSON());
        }
        if (Array.isArray(this.webLinks)) {
            data["webLinks"] = [];
            for (let item of this.webLinks)
                data["webLinks"].push(item.toJSON());
        }
        data["thumbnail"] = this.thumbnail ? this.thumbnail.toJSON() : undefined;
        return data;
    }
}
/** The details of a collection summary. */
export class CollectionSummaryDetailsResponse {
    /** Gets or sets the unique identifier for the collection. */
    id;
    /** Gets or sets the name of the collection. */
    name;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionSummaryDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}
/** A summary of the collection. */
export class CollectionSummaryResponse {
    details;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? CollectionSummaryDetailsResponse.fromJS(_data["details"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionSummaryResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        return data;
    }
}
/** The collection broadcast details response. */
export class CollectionVideoDetailsResponse {
    /** Gets or sets the id. */
    id;
    /** Gets or Sets the video player playlists id. */
    videoPlayerPlaylistId;
    /** Gets or Sets the broadcast id. */
    broadcastId;
    /** Gets or sets a value indicating whether email gating enabled. */
    isEmailGatingEnabled;
    /** Gets or sets a value indicating whether password gating enabled. */
    isPasswordGatingEnabled;
    /** Gets or Sets the rank. */
    ordinalRank_Rank;
    /** Gets or Sets the ordinal. */
    ordinalRank_Ordinal;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.videoPlayerPlaylistId = _data["videoPlayerPlaylistId"];
            this.broadcastId = _data["broadcastId"];
            this.isEmailGatingEnabled = _data["isEmailGatingEnabled"];
            this.isPasswordGatingEnabled = _data["isPasswordGatingEnabled"];
            this.ordinalRank_Rank = _data["ordinalRank_Rank"];
            this.ordinalRank_Ordinal = _data["ordinalRank_Ordinal"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionVideoDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["videoPlayerPlaylistId"] = this.videoPlayerPlaylistId;
        data["broadcastId"] = this.broadcastId;
        data["isEmailGatingEnabled"] = this.isEmailGatingEnabled;
        data["isPasswordGatingEnabled"] = this.isPasswordGatingEnabled;
        data["ordinalRank_Rank"] = this.ordinalRank_Rank;
        data["ordinalRank_Ordinal"] = this.ordinalRank_Ordinal;
        return data;
    }
}
/** The collection broadcast response. */
export class CollectionVideoResponse {
    details;
    /** Gets a value indicating whether gated. */
    isGated;
    /** Gets a value indicating whether entitled. */
    isEntitled;
    /** Gets or sets the entitlements. */
    entitlements;
    broadcast;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? CollectionVideoDetailsResponse.fromJS(_data["details"]) : undefined;
            this.isGated = _data["isGated"];
            this.isEntitled = _data["isEntitled"];
            if (Array.isArray(_data["entitlements"])) {
                this.entitlements = [];
                for (let item of _data["entitlements"])
                    this.entitlements.push(EntitlementResponse.fromJS(item));
            }
            this.broadcast = _data["broadcast"] ? BroadcastResponse.fromJS(_data["broadcast"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionVideoResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        data["isGated"] = this.isGated;
        data["isEntitled"] = this.isEntitled;
        if (Array.isArray(this.entitlements)) {
            data["entitlements"] = [];
            for (let item of this.entitlements)
                data["entitlements"].push(item.toJSON());
        }
        data["broadcast"] = this.broadcast ? this.broadcast.toJSON() : undefined;
        return data;
    }
}
/** Response for a specific collection video search result. */
export class CollectionVideoSearchResponse {
    collection;
    video;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.collection = _data["collection"] ? CollectionSummaryResponse.fromJS(_data["collection"]) : undefined;
            this.video = _data["video"] ? CollectionVideoResponse.fromJS(_data["video"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionVideoSearchResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["collection"] = this.collection ? this.collection.toJSON() : undefined;
        data["video"] = this.video ? this.video.toJSON() : undefined;
        return data;
    }
}
/** The collection videos paged response. */
export class CollectionVideosPagedResponse {
    /** Gets or sets the video player id. */
    collectionId;
    /** Gets or sets the items. */
    items;
    /** Gets or sets the total pages. */
    totalPages;
    /** Gets or sets the total records. */
    totalRecords;
    /** Gets or sets the page. */
    page;
    /** Gets or sets the page size. */
    pageSize;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.collectionId = _data["collectionId"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(CollectionVideoResponse.fromJS(item));
            }
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionVideosPagedResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["collectionId"] = this.collectionId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}
/** The collection videos response. */
export class CollectionVideosResponse {
    /** Gets or sets the video player id. */
    collectionId;
    /** Gets or sets the items. */
    items;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.collectionId = _data["collectionId"];
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(CollectionVideoResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionVideosResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["collectionId"] = this.collectionId;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
/** The collections paged response. */
export class CollectionsPagedResponse {
    /** Gets or sets the collections. */
    collections;
    /** Gets or sets the total pages. */
    totalPages;
    /** Gets or sets the total records. */
    totalRecords;
    /** Gets or sets the page. */
    page;
    /** Gets or sets the page size. */
    pageSize;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["collections"])) {
                this.collections = [];
                for (let item of _data["collections"])
                    this.collections.push(CollectionResponse.fromJS(item));
            }
            this.totalPages = _data["totalPages"];
            this.totalRecords = _data["totalRecords"];
            this.page = _data["page"];
            this.pageSize = _data["pageSize"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new CollectionsPagedResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.collections)) {
            data["collections"] = [];
            for (let item of this.collections)
                data["collections"].push(item.toJSON());
        }
        data["totalPages"] = this.totalPages;
        data["totalRecords"] = this.totalRecords;
        data["page"] = this.page;
        data["pageSize"] = this.pageSize;
        return data;
    }
}
/** The email redemption details response. */
export class EmailRedemptionDetailsResponse {
    /** The Id of the email redemption */
    id;
    /** Gets or sets the entity id. */
    entityId;
    /** The email address of the email redemption */
    email;
    /** The date/time the email redemption was created */
    createdAt;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.email = _data["email"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EmailRedemptionDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["email"] = this.email;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
/** The email redemption response. */
export class EmailRedemptionResponse {
    details;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.details = new EmailRedemptionDetailsResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? EmailRedemptionDetailsResponse.fromJS(_data["details"]) : new EmailRedemptionDetailsResponse();
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EmailRedemptionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        return data;
    }
}
/** The entitlement details response. */
export class EntitlementDetailsResponse {
    /** Gets or sets the id. */
    id;
    /** Gets or sets the product id. */
    productId;
    type;
    redemptionType;
    /** Gets or sets the entitlement id. */
    entitlementId;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.type = _data["type"];
            this.redemptionType = _data["redemptionType"];
            this.entitlementId = _data["entitlementId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EntitlementDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["type"] = this.type;
        data["redemptionType"] = this.redemptionType;
        data["entitlementId"] = this.entitlementId;
        return data;
    }
}
/** The entitlement price details response. */
export class EntitlementPriceDetailsResponse {
    /** Gets or sets the id. */
    id;
    /** Gets or sets the name. */
    name;
    /** Gets or sets the description. */
    description;
    /** Gets or sets the amount. */
    amount;
    /** Gets or sets a value indicating whether recurring. */
    isRecurring;
    /** Gets or sets a value indicating whether active. */
    isActive;
    /** Gets or sets a value indicating whether public. */
    isPublic;
    /** Gets or sets a value indicating whether the price has a limited time access. */
    isTimeLimitedAccess;
    entitledDurationUnit;
    /** Gets or sets the entitled duration. */
    entitledDuration;
    purchaseInterval;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.amount = _data["amount"];
            this.isRecurring = _data["isRecurring"];
            this.isActive = _data["isActive"];
            this.isPublic = _data["isPublic"];
            this.isTimeLimitedAccess = _data["isTimeLimitedAccess"];
            this.entitledDurationUnit = _data["entitledDurationUnit"];
            this.entitledDuration = _data["entitledDuration"];
            this.purchaseInterval = _data["purchaseInterval"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EntitlementPriceDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["amount"] = this.amount;
        data["isRecurring"] = this.isRecurring;
        data["isActive"] = this.isActive;
        data["isPublic"] = this.isPublic;
        data["isTimeLimitedAccess"] = this.isTimeLimitedAccess;
        data["entitledDurationUnit"] = this.entitledDurationUnit;
        data["entitledDuration"] = this.entitledDuration;
        data["purchaseInterval"] = this.purchaseInterval;
        return data;
    }
}
/** The entitlement price response. */
export class EntitlementPriceResponse {
    details;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.details = new EntitlementPriceDetailsResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? EntitlementPriceDetailsResponse.fromJS(_data["details"]) : new EntitlementPriceDetailsResponse();
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EntitlementPriceResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        return data;
    }
}
/** The entitlement product details response. */
export class EntitlementProductDetailsResponse {
    /** Gets or sets the id. */
    id;
    /** Gets or sets the name. */
    name;
    /** Gets or sets the description. */
    description;
    /** Gets or sets the entitled duration seconds. */
    entitledDurationSeconds;
    /** Gets or sets a value indicating whether active. */
    isActive;
    /** Gets or sets the stripe account id. */
    stripeAccountId;
    /** Gets or sets the billing portal configuration id. */
    billingPortalConfigurationId;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.entitledDurationSeconds = _data["entitledDurationSeconds"];
            this.isActive = _data["isActive"];
            this.stripeAccountId = _data["stripeAccountId"];
            this.billingPortalConfigurationId = _data["billingPortalConfigurationId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EntitlementProductDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["entitledDurationSeconds"] = this.entitledDurationSeconds;
        data["isActive"] = this.isActive;
        data["stripeAccountId"] = this.stripeAccountId;
        data["billingPortalConfigurationId"] = this.billingPortalConfigurationId;
        return data;
    }
}
/** The entitlement product response. */
export class EntitlementProductResponse {
    details;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.details = new EntitlementProductDetailsResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? EntitlementProductDetailsResponse.fromJS(_data["details"]) : new EntitlementProductDetailsResponse();
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EntitlementProductResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        return data;
    }
}
/** The entitlement response. */
export class EntitlementResponse {
    details;
    product;
    /** Gets or sets the prices. */
    prices;
    /** Gets or sets the purchases. */
    purchases;
    /** Gets or sets the email redemptions. */
    emailRedemptions;
    /** Gets or sets the password redemptions. */
    passwordRedemptions;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.details = new EntitlementDetailsResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? EntitlementDetailsResponse.fromJS(_data["details"]) : new EntitlementDetailsResponse();
            this.product = _data["product"] ? EntitlementProductResponse.fromJS(_data["product"]) : undefined;
            if (Array.isArray(_data["prices"])) {
                this.prices = [];
                for (let item of _data["prices"])
                    this.prices.push(EntitlementPriceResponse.fromJS(item));
            }
            if (Array.isArray(_data["purchases"])) {
                this.purchases = [];
                for (let item of _data["purchases"])
                    this.purchases.push(PurchaseResponse.fromJS(item));
            }
            if (Array.isArray(_data["emailRedemptions"])) {
                this.emailRedemptions = [];
                for (let item of _data["emailRedemptions"])
                    this.emailRedemptions.push(EmailRedemptionResponse.fromJS(item));
            }
            if (Array.isArray(_data["passwordRedemptions"])) {
                this.passwordRedemptions = [];
                for (let item of _data["passwordRedemptions"])
                    this.passwordRedemptions.push(PasswordRedemptionResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new EntitlementResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        data["product"] = this.product ? this.product.toJSON() : undefined;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        if (Array.isArray(this.purchases)) {
            data["purchases"] = [];
            for (let item of this.purchases)
                data["purchases"].push(item.toJSON());
        }
        if (Array.isArray(this.emailRedemptions)) {
            data["emailRedemptions"] = [];
            for (let item of this.emailRedemptions)
                data["emailRedemptions"].push(item.toJSON());
        }
        if (Array.isArray(this.passwordRedemptions)) {
            data["passwordRedemptions"] = [];
            for (let item of this.passwordRedemptions)
                data["passwordRedemptions"].push(item.toJSON());
        }
        return data;
    }
}
/** The owner details response. */
export class OwnerDetailsResponse {
    /** Gets or sets the user id. */
    userId;
    /** Gets or sets the stripe account id. */
    stripeAccountId;
    /** Gets or sets the organization id. */
    organizationId;
    /** Gets or sets the project id. */
    projectId;
    /** Gets or sets whether or not charges are enabled. */
    chargesEnabled;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.userId = _data["userId"];
            this.stripeAccountId = _data["stripeAccountId"];
            this.organizationId = _data["organizationId"];
            this.projectId = _data["projectId"];
            this.chargesEnabled = _data["chargesEnabled"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["userId"] = this.userId;
        data["stripeAccountId"] = this.stripeAccountId;
        data["organizationId"] = this.organizationId;
        data["projectId"] = this.projectId;
        data["chargesEnabled"] = this.chargesEnabled;
        return data;
    }
}
/** The owner response. */
export class OwnerResponse {
    details;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? OwnerDetailsResponse.fromJS(_data["details"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new OwnerResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        return data;
    }
}
/** The password redemption details response. */
export class PasswordRedemptionDetailsResponse {
    /** The Id of the password redemption */
    id;
    /** Gets or sets the entity id. */
    entityId;
    /** The date/time the password redemption was created */
    createdAt;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.entityId = _data["entityId"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordRedemptionDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["entityId"] = this.entityId;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : undefined;
        return data;
    }
}
/** The password redemption response. */
export class PasswordRedemptionResponse {
    details;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.details = new PasswordRedemptionDetailsResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? PasswordRedemptionDetailsResponse.fromJS(_data["details"]) : new PasswordRedemptionDetailsResponse();
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordRedemptionResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        return data;
    }
}
/** The password validation entity details response. */
export class PasswordValidationEntityDetailsResponse {
    entityType;
    /** Gets or sets the entity id. */
    entityId;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordValidationEntityDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        return data;
    }
}
/** The password validation entity request. */
export class PasswordValidationEntityRequest {
    entityType;
    /** Gets or sets the entity id. */
    entityId;
    /** Gets or sets the project id. */
    projectId;
    /** Gets or sets the entity name. */
    entityName;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.entityType = _data["entityType"];
            this.entityId = _data["entityId"];
            this.projectId = _data["projectId"];
            this.entityName = _data["entityName"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordValidationEntityRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["entityType"] = this.entityType;
        data["entityId"] = this.entityId;
        data["projectId"] = this.projectId;
        data["entityName"] = this.entityName;
        return data;
    }
}
/** The password validation entity response. */
export class PasswordValidationEntityResponse {
    details;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? PasswordValidationEntityDetailsResponse.fromJS(_data["details"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordValidationEntityResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        return data;
    }
}
/** The password validation request. */
export class PasswordValidationRequest {
    /** Gets or sets the password. */
    password;
    /** Gets or sets the entities. */
    entities;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.password = _data["password"];
            if (Array.isArray(_data["entities"])) {
                this.entities = [];
                for (let item of _data["entities"])
                    this.entities.push(PasswordValidationEntityRequest.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordValidationRequest();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["password"] = this.password;
        if (Array.isArray(this.entities)) {
            data["entities"] = [];
            for (let item of this.entities)
                data["entities"].push(item.toJSON());
        }
        return data;
    }
}
/** The password validation response. */
export class PasswordValidationResponse {
    /** Gets or sets a value indicating whether valid. */
    isValid;
    /** Gets or sets the valid entities. */
    validEntities;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.isValid = _data["isValid"];
            if (Array.isArray(_data["validEntities"])) {
                this.validEntities = [];
                for (let item of _data["validEntities"])
                    this.validEntities.push(PasswordValidationEntityResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PasswordValidationResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["isValid"] = this.isValid;
        if (Array.isArray(this.validEntities)) {
            data["validEntities"] = [];
            for (let item of this.validEntities)
                data["validEntities"].push(item.toJSON());
        }
        return data;
    }
}
export class ProblemDetails {
    type;
    title;
    status;
    detail;
    instance;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}
/** The product meta data response. */
export class ProductMetaDataDetailsResponse {
    /** Gets or sets the total collections. */
    totalCollections;
    /** Gets or sets the total videos. */
    totalVideos;
    /** Gets or sets the last updated. */
    lastUpdated;
    /** Gets or sets the product id. */
    productId;
    entitlementType;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.totalCollections = _data["totalCollections"];
            this.totalVideos = _data["totalVideos"];
            this.lastUpdated = _data["lastUpdated"] ? new Date(_data["lastUpdated"].toString()) : undefined;
            this.productId = _data["productId"];
            this.entitlementType = _data["entitlementType"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMetaDataDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["totalCollections"] = this.totalCollections;
        data["totalVideos"] = this.totalVideos;
        data["lastUpdated"] = this.lastUpdated ? this.lastUpdated.toISOString() : undefined;
        data["productId"] = this.productId;
        data["entitlementType"] = this.entitlementType;
        return data;
    }
}
/** The meta data response. */
export class ProductMetaDataDetailsResponseMetaDataResponse {
    /** Gets or sets the items. */
    items;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [];
                for (let item of _data["items"])
                    this.items.push(ProductMetaDataDetailsResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ProductMetaDataDetailsResponseMetaDataResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}
/** The purchase details response. */
export class PurchaseDetailsResponse {
    /** The Invoice Or Subscription Id */
    id;
    /** Gets or sets the product id. */
    productId;
    /** Gets or sets the customer id. */
    customerId;
    /** Gets or sets the price ids. */
    priceIds;
    /** Gets or sets the total amount. */
    totalAmount;
    /** Gets or sets the invoice date. */
    invoiceDate;
    purchaseInterval;
    purchaseType;
    /** One Time Passes will need to calculated the Period End based on the duration set on the price.
Subscription will set this value based on the end of the interval */
    currentPeriodEnd;
    /** Gets or sets the canceled at. */
    canceledAt;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.productId = _data["productId"];
            this.customerId = _data["customerId"];
            if (Array.isArray(_data["priceIds"])) {
                this.priceIds = [];
                for (let item of _data["priceIds"])
                    this.priceIds.push(item);
            }
            this.totalAmount = _data["totalAmount"];
            this.invoiceDate = _data["invoiceDate"] ? new Date(_data["invoiceDate"].toString()) : undefined;
            this.purchaseInterval = _data["purchaseInterval"];
            this.purchaseType = _data["purchaseType"];
            this.currentPeriodEnd = _data["currentPeriodEnd"] ? new Date(_data["currentPeriodEnd"].toString()) : undefined;
            this.canceledAt = _data["canceledAt"] ? new Date(_data["canceledAt"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["productId"] = this.productId;
        data["customerId"] = this.customerId;
        if (Array.isArray(this.priceIds)) {
            data["priceIds"] = [];
            for (let item of this.priceIds)
                data["priceIds"].push(item);
        }
        data["totalAmount"] = this.totalAmount;
        data["invoiceDate"] = this.invoiceDate ? this.invoiceDate.toISOString() : undefined;
        data["purchaseInterval"] = this.purchaseInterval;
        data["purchaseType"] = this.purchaseType;
        data["currentPeriodEnd"] = this.currentPeriodEnd ? this.currentPeriodEnd.toISOString() : undefined;
        data["canceledAt"] = this.canceledAt ? this.canceledAt.toISOString() : undefined;
        return data;
    }
}
/** The purchase response. */
export class PurchaseResponse {
    details;
    product;
    /** Gets or sets the prices. */
    prices;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.details = new PurchaseDetailsResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? PurchaseDetailsResponse.fromJS(_data["details"]) : new PurchaseDetailsResponse();
            this.product = _data["product"] ? EntitlementProductResponse.fromJS(_data["product"]) : undefined;
            if (Array.isArray(_data["prices"])) {
                this.prices = [];
                for (let item of _data["prices"])
                    this.prices.push(EntitlementPriceResponse.fromJS(item));
            }
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new PurchaseResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        data["product"] = this.product ? this.product.toJSON() : undefined;
        if (Array.isArray(this.prices)) {
            data["prices"] = [];
            for (let item of this.prices)
                data["prices"].push(item.toJSON());
        }
        return data;
    }
}
/** Response for a successful slug lookup. */
export class SlugLookupResponse {
    type;
    /** The Id of the entity the slug is for. */
    id;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.type = _data["type"];
            this.id = _data["id"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new SlugLookupResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["type"] = this.type;
        data["id"] = this.id;
        return data;
    }
}
/** The thumbnail details response. */
export class ThumbnailDetailsResponse {
    /** The id. */
    id;
    /** The thumbnail url. */
    url;
    /** The thumbnail access expiration date. */
    expiresOn;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.url = _data["url"];
            this.expiresOn = _data["expiresOn"] ? new Date(_data["expiresOn"].toString()) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ThumbnailDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["url"] = this.url;
        data["expiresOn"] = this.expiresOn ? this.expiresOn.toISOString() : undefined;
        return data;
    }
}
/** The thumbnail response. */
export class ThumbnailResponse {
    details;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.details = new ThumbnailDetailsResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? ThumbnailDetailsResponse.fromJS(_data["details"]) : new ThumbnailDetailsResponse();
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new ThumbnailResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        return data;
    }
}
/** The video details dimensions response. */
export class VideoDetailsDimensionsResponse {
    /** Gets or sets the width. */
    width;
    /** Gets or sets the height. */
    height;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.width = _data["width"];
            this.height = _data["height"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDetailsDimensionsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["width"] = this.width;
        data["height"] = this.height;
        return data;
    }
}
/** The video details playback response. */
export class VideoDetailsPlaybackResponse {
    /** Gets or sets the HLS. */
    hls;
    /** Gets or sets the dash. */
    dash;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.hls = _data["hls"];
            this.dash = _data["dash"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDetailsPlaybackResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["hls"] = this.hls;
        data["dash"] = this.dash;
        return data;
    }
}
/** The video details response. */
export class VideoDetailsResponse {
    /** Gets or sets the uid. */
    uid;
    /** Gets or sets the creator. */
    creator;
    /** Gets or sets the thumbnail. */
    thumbnail;
    /** Gets or sets  a value indicating whether to ready converts to stream. */
    readyToStream;
    /** Gets or sets the status. */
    status;
    /** Gets or sets the created. */
    created;
    /** Gets or sets the uploaded. */
    uploaded;
    /** Gets or sets the duration. */
    duration;
    input;
    playback;
    /** Gets or sets the live input. */
    liveInput;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.uid = _data["uid"];
            this.creator = _data["creator"];
            this.thumbnail = _data["thumbnail"];
            this.readyToStream = _data["readyToStream"];
            this.status = _data["status"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : undefined;
            this.uploaded = _data["uploaded"] ? new Date(_data["uploaded"].toString()) : undefined;
            this.duration = _data["duration"];
            this.input = _data["input"] ? VideoDetailsDimensionsResponse.fromJS(_data["input"]) : undefined;
            this.playback = _data["playback"] ? VideoDetailsPlaybackResponse.fromJS(_data["playback"]) : undefined;
            this.liveInput = _data["liveInput"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new VideoDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["uid"] = this.uid;
        data["creator"] = this.creator;
        data["thumbnail"] = this.thumbnail;
        data["readyToStream"] = this.readyToStream;
        data["status"] = this.status;
        data["created"] = this.created ? this.created.toISOString() : undefined;
        data["uploaded"] = this.uploaded ? this.uploaded.toISOString() : undefined;
        data["duration"] = this.duration;
        data["input"] = this.input ? this.input.toJSON() : undefined;
        data["playback"] = this.playback ? this.playback.toJSON() : undefined;
        data["liveInput"] = this.liveInput;
        return data;
    }
}
/** The video response. */
export class VideoResponse {
    details;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? VideoDetailsResponse.fromJS(_data["details"]) : undefined;
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new VideoResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        return data;
    }
}
/** The web link details response. */
export class WebLinkDetailsResponse {
    /** Gets or Sets the id. */
    id;
    /** Gets or Sets the link. */
    link;
    /** Gets or Sets the title. */
    title;
    /** Gets or Sets the sequence. */
    sequence;
    /** Gets or Sets the video player id. */
    videoPlayerId;
    /** Gets or Sets the broadcast id. */
    broadcastId;
    /** Gets or Sets whether purchase is required to view the web link. */
    purchaseRequired;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
    }
    init(_data) {
        if (_data) {
            this.id = _data["id"];
            this.link = _data["link"];
            this.title = _data["title"];
            this.sequence = _data["sequence"];
            this.videoPlayerId = _data["videoPlayerId"];
            this.broadcastId = _data["broadcastId"];
            this.purchaseRequired = _data["purchaseRequired"];
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new WebLinkDetailsResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["link"] = this.link;
        data["title"] = this.title;
        data["sequence"] = this.sequence;
        data["videoPlayerId"] = this.videoPlayerId;
        data["broadcastId"] = this.broadcastId;
        data["purchaseRequired"] = this.purchaseRequired;
        return data;
    }
}
/** The web link response. */
export class WebLinkResponse {
    details;
    constructor(data) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    this[property] = data[property];
            }
        }
        if (!data) {
            this.details = new WebLinkDetailsResponse();
        }
    }
    init(_data) {
        if (_data) {
            this.details = _data["details"] ? WebLinkDetailsResponse.fromJS(_data["details"]) : new WebLinkDetailsResponse();
        }
    }
    static fromJS(data) {
        data = typeof data === 'object' ? data : {};
        let result = new WebLinkResponse();
        result.init(data);
        return result;
    }
    toJSON(data) {
        data = typeof data === 'object' ? data : {};
        data["details"] = this.details ? this.details.toJSON() : undefined;
        return data;
    }
}
export class SwaggerException extends Error {
    message;
    status;
    response;
    headers;
    result;
    constructor(message, status, response, headers, result) {
        super();
        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }
    isSwaggerException = true;
    static isSwaggerException(obj) {
        return obj.isSwaggerException === true;
    }
}
function throwException(message, status, response, headers, result) {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new SwaggerException(message, status, response, headers, null);
}
